import type { ApiClient } from '@volee/api-client'
import type { components } from '@volee/api-types'

import { api } from '../services/api.ts'

// «Password dimenticata?», ours and not the pool's (spec #278, #295, #296): a username tells its
// tutori; a mail gets our six-digit code, the tutori too under 14, and the code sets the password.

export type PasswordRecoveryConfirmation = components['schemas']['PasswordRecoveryConfirmation']

/** `authenticated: false`: whoever forgot the password has no session to send. Always an empty 202. */
export function requestPasswordRecovery(client: ApiClient, identifier: string): Promise<void> {
  return client.post<void>('/v1/public/password-recovery', { identifier }, { authenticated: false })
}

/** A 204 once the pool took the password; a 422 on `code` or on `password` otherwise. */
export function confirmPasswordRecovery(
  client: ApiClient,
  body: PasswordRecoveryConfirmation,
): Promise<void> {
  return client.post<void>('/v1/public/password-recovery/confirm', body, { authenticated: false })
}

// Indirection with a purpose: a test replaces these, whereas a spy on this module's own exports
// cannot rebind a call the module makes to itself.
export const passwordRecoveryWriter = {
  request: (identifier: string) => requestPasswordRecovery(api, identifier),
  confirm: (body: PasswordRecoveryConfirmation) => confirmPasswordRecovery(api, body),
}
